import { render, staticRenderFns } from "./BannedCountries.vue?vue&type=template&id=0cd8a02c&scoped=true&"
import script from "./BannedCountries.vue?vue&type=script&lang=ts&"
export * from "./BannedCountries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8a02c",
  null
  
)

export default component.exports